class Allergen {
  constructor({ name, icon }) {
    this.name = name;
    this.icon = icon;
  }

  toMap() {
    return { name: this.name, icon: this.icon };
  }

  static fromMap(obj) {
    return new Allergen(obj);
  }
}

export default Allergen;
